<template>
  <div id="introCss">
                <span class="topTitle">
                  <label>推荐商品</label>
<!--                  <label>换一批</label>-->
                </span>

    <div class="goodsInfo">
                 <span class="gdetail" :style="SBXH=='PC'?'width:23%;':'width:32%;'" v-for="(item,index) in goodsLst" v-if="SBXH=='PC'?index<4:index<3" @click="goDtl(item.GOODS_ID)">
                  <el-image :src="imgBSUrl+item.IMG" style="width:100%;height:auto;border-top-left-radius: 0.5rem;border-top-right-radius: 0.5rem;"></el-image>
                  <label-wrap style="padding:0.5rem;height:70px;font-size: 1.3rem;">{{item.REMARK2}}</label-wrap>
                  <label style="padding-bottom: 10px;color:red;font-size: 2.2rem;"><i style="font-size: 1rem;">￥</i>{{item.PRICE}}</label>
                </span>
    </div>
  </div>
</template>

<script>
import { getSBXH} from "../../api/common.js";

export default {
  name: "intro-goods",
  props:['goodsLst'],
  data(){
    return{
      imgBSUrl: '',
      SBXH:''

    }
  },
  created() {
    this.imgBSUrl = this.$imgBaseUrl;
    this.SBXH=getSBXH();
  },
  methods: {
    goDtl(goodsid){

      const {href} = this.$router.resolve({
        name: 'Detail', query: {goodsid: goodsid}
      })
      window.open(href)
    }
  }


}
</script>

<style scoped>
#introCss{
  display: flex;
  flex-direction: column;
  /*margin: 15px;*/
  border: 1px solid #CCCCCC;
  padding: 15px;
  border-radius: 0.5rem;
}
#introCss .topTitle{
  display: flex;
  justify-content: space-between;
}
#introCss .goodsInfo{
  display: flex;
  justify-content: space-between;
  margin-top:15px;
}
#introCss .goodsInfo .gdetail{
  display: flex;
  flex-direction: column;
  box-shadow:1px 4px 6px #CCCCCC;
  align-items: center;
  font-size: 1.4rem;
  /*font-family: serif;*/
  /*font-weight: bold;*/

  margin-top:15px;
  margin-right: 2%;
  border-radius: 0.5rem;
}
#introCss .goodsInfo .gdetail:hover{
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/sidebar/intro-goods.vue